// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.details-list[data-v-bacf848c] {\r\n  max-height: calc(100vh - 200px);\r\n  overflow-y: auto;\n}\r\n", ""]);
// Exports
module.exports = exports;
